import React from 'react'
import Chip from '@mui/material/Chip'

/**
 * Quick date-range chips (Today / This Week / ... / Custom). Selecting a preset is the
 * parent's job (it owns the range state and the refetch); 'custom' is activated
 * implicitly whenever the operator edits a calendar, so its chip is just a state
 * indicator that never imposes a range.
 */
const DateRangePresets = ({ presets = [], active, onSelect }) => (
  <div className="flex flex-wrap items-center gap-1.5" role="group" aria-label="Quick date ranges" data-testid="date-presets">
    {presets.map(({ key, label }) => {
      const isActive = active === key
      return (
        <Chip
          key={key}
          size="small"
          data-testid={`date-preset-${key}`}
          onClick={() => onSelect(key)}
          aria-pressed={isActive}
          color={isActive ? 'primary' : 'default'}
          variant={isActive ? 'filled' : 'outlined'}
          label={label}
        />
      )
    })}
  </div>
)

export default DateRangePresets
